import { AxiosMessages, ProblemDetails } from './_axiosErrorTypes';
import axios, { AxiosError } from 'axios';
import { axiosMessages } from './axiosMessages';
import { getStoredLanguage } from '../utils/languageStorage';

export function handleAxiosError(error: AxiosError): string {
    if (isServiceUnavailableError(error)) {
        return getErrorMessage('AXIOS_ERROR_SERVICE_UNAVAILABLE');
    }

    let errorMessage = error.message;
    if (error.response) {
        const statusCode = error.response.status;
        const responseData = error.response?.data;

        if (responseData && typeof responseData === 'object' && 'title' in responseData && 'detail' in responseData) {
            const problemDetails = responseData as ProblemDetails;
            errorMessage = `${problemDetails.detail}`;
        } else if (responseData && typeof responseData === 'object' && 'message' in responseData) {
            errorMessage = String(responseData.message);
        } else {
            switch (statusCode) {
                case 401:
                    errorMessage = getErrorMessage('AXIOS_ERROR_401');
                    break;
                case 403:
                    errorMessage = getErrorMessage('AXIOS_ERROR_403');
                    break;
                case 404:
                    errorMessage = getErrorMessage('AXIOS_ERROR_404');
                    break;
                default:
                    errorMessage = `${getErrorMessage('AXIOS_ERROR_OCCURRED')}: ${statusCode} - ${error.response.statusText}`;
            }
        }
    } else if (error.request) {
        errorMessage = getErrorMessage('AXIOS_ERROR_SERVICE_UNAVAILABLE');
    } else {
        errorMessage = getErrorMessage('AXIOS_ERROR_REQUEST');
    }

    return errorMessage || getErrorMessage('AXIOS_ERROR_OCCURRED');
}

const unavailableStatusCodes = new Set([502, 503, 504, 521, 522, 523, 524]);

export function isServiceUnavailableError(error: unknown): boolean {
    if (!axios.isAxiosError(error) || axios.isCancel(error) || error.code === 'ERR_CANCELED') return false;

    const statusCode = error.response?.status;
    if (statusCode != null) return unavailableStatusCodes.has(statusCode);

    return Boolean(error.request);
}

function getErrorMessage(key: keyof AxiosMessages['en']): string {
    const lang = getSelectedLanguage() as keyof AxiosMessages;
    return axiosMessages[lang][key] || axiosMessages['en'][key] || 'An unknown error occurred';
}

function getSelectedLanguage(): string {
    return getStoredLanguage();
}
